import React, { FC } from 'react';
import { GetGuideQuery } from '../__generated__/graphql';
import { Unpacked } from '../graphQLTypes/types';
import { useModal } from '../dialogs/useModal';
import { GuideCommentDialog, GuideCommentDialogInput } from './CommentDialog';
import { CommentsCard } from '../comments/CommentsCard';
import { useGuideCommentActions } from './useGuideCommentActions';

type Comment = Unpacked<NonNullable<GetGuideQuery['guide']>['comments']>;

export const Comments: FC<{ guideId: string; comments: Comment[]; onUpdate: () => Promise<unknown> }> = ({ guideId, comments, onUpdate }) => {
  const commentDialog = useModal<GuideCommentDialogInput, boolean>({ data: { guideId } });
  const actions = useGuideCommentActions();

  const add = async () => {
    const result = await commentDialog.open({ guideId });
    if (result) {
      await onUpdate();
    }
  };

  return (
    <CommentsCard comments={comments.filter((c): c is NonNullable<Comment> => !!c)} actions={actions} onAdd={add}>
      {commentDialog.isOpen && <GuideCommentDialog modal={commentDialog} />}
    </CommentsCard>
  );
};
